const prices = {
  table: {
    service: "Υπηρεσία",
    priceBgn: "Τιμή (BGN)",
    priceEur: "Τιμή (€)",
    missing: "—",
  },
  hero: {
    title: "Τιμοκατάλογος",
    description:
      "Ενδεικτικές τιμές σε BGN και EUR. Για εξατομικευμένο πλάνο θεραπείας και ακριβή προσφορά, επικοινωνήστε μαζί μας.",
  },
  section: {
    title: "Τιμές ανά υπηρεσία",
    description:
      "Για ερωτήσεις ή για να κλείσετε ραντεβού, χρησιμοποιήστε τη φόρμα επικοινωνίας.",
  },
  // NOTE: No Prices page in GR reference repo; translated from EN source copy.
  cards: [
    {
      title: "Στεφάνες",
      rows: [
        { name: "1 τεμ. στεφάνη MK", bgn: "430 BGN", eur: "€219.86" },
        { name: "1 τεμ. στεφάνη ZR", bgn: "800 BGN", eur: "€409.04" },
        {
          name: "1 τεμ. επιμήκυνση κλινικής μύλης",
          bgn: "500 BGN",
          eur: "€255.65",
        },
        {
          name: "1 τεμ. προσωρινή στεφάνη / εργαστηρίου",
          bgn: "40 BGN",
          eur: "€20.45",
        },
      ],
    },
    {
      title: "All-on-4",
      sections: [
        {
          title: "Σύνθετη ρητίνη (composite)",
          rows: [
            { name: "1 γνάθος", bgn: "4,500 BGN", eur: "€2,300.85" },
            { name: "2 γνάθοι", bgn: "9,000 BGN", eur: "€4,601.70" },
          ],
        },
        {
          title: "Μεταλλοκεραμική",
          rows: [
            { name: "1 γνάθος", bgn: "6,000 BGN", eur: "€3,067.80" },
            { name: "2 γνάθοι", bgn: "12,000 BGN", eur: "€6,135.60" },
          ],
        },
      ],
    },
    {
      title: "All-on-6",
      sections: [
        {
          title: "Μεταλλοκεραμική",
          rows: [
            { name: "1 γνάθος", bgn: "8,000 BGN", eur: "€4,090.40" },
            { name: "2 γνάθοι", bgn: "16,000 BGN", eur: "€8,180.80" },
          ],
        },
        {
          title: "Ζιρκόνιο",
          rows: [
            { name: "1 γνάθος", bgn: "9,500 BGN", eur: "€4,857.35" },
            { name: "2 γνάθοι", bgn: "19,000 BGN", eur: "€9,714.69" },
          ],
        },
      ],
    },
    {
      title: "Προσθετική",
      rows: [
        { name: "Οδοντοστοιχία ακρυλική", bgn: "650 BGN", eur: "€332.34" },
        { name: "Οδοντοστοιχία σιλικόνης", bgn: "900 BGN", eur: "€460.17" },
        { name: "Μερική ακρυλική", bgn: "450 BGN", eur: "€230.08" },
      ],
    },
    {
      title: "Καθαρισμός πέτρας",
      rows: [{ name: "Καθαρισμός (αποτρύγωση) και στίλβωση", bgn: "170 BGN", eur: "€86.92" }],
    },
    {
      title: "Σφραγίσματα",
      rows: [
        { name: "1 επιφάνεια", bgn: "120 BGN", eur: "€61.36" },
        { name: "2 επιφάνειες", bgn: "150 BGN", eur: "€76.69" },
        { name: "3 επιφάνειες", bgn: "180 BGN", eur: "€92.03" },
        { name: "μετά από ενδοδοντική θεραπεία", note: "ανάλογα με τις επιφάνειες" },
      ],
    },
    {
      title: "Ανασύσταση με άξονα",
      rows: [
        { name: "Μεταλλικός άξονας", bgn: "150 BGN", eur: "€76.69" },
        { name: "Άξονας ζιρκονίου", bgn: "250 BGN", eur: "€127.82" },
      ],
    },
    {
      title: "Εξαγωγές",
      rows: [
        { name: "Δόντι με 1 ρίζα", bgn: "150 BGN", eur: "€76.69" },
        { name: "Δόντι με πολλές ρίζες", bgn: "200 BGN", eur: "€102.26" },
        { name: "Φρονιμίτης", bgn: "300 BGN", eur: "€153.39" },
        { name: "Έγκλειστος φρονιμίτης", bgn: "400 BGN", eur: "€204.52" },
      ],
    },
    {
      title: "Λεύκανση",
      rows: [
        { name: "Στο ιατρείο", bgn: "500 BGN", eur: "€255.65" },
        { name: "Στο σπίτι", bgn: "400 BGN", eur: "€204.52" },
      ],
    },
    {
      title: "Αισθητικές θεραπείες",
      rows: [
        { name: "Όψεις E-max", bgn: "700 BGN", eur: "€357.91" },
        { name: "Bonding / 1 δόντι", bgn: "300 BGN", eur: "€153.39" },
      ],
    },
    {
      title: "Ακτινογραφία",
      rows: [{ name: "Πανοραμική ακτινογραφία", bgn: "35 BGN", eur: "€17.90" }],
    },
    {
      title: "Οστό",
      rows: [{ name: "Οστό 1 τεμ.", bgn: "2,000 BGN", eur: "€1,022.60" }],
    },
  ],
};

export default prices;

